import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled MidasController
 *
 * @param props - icoSrc, title
 * @example
 * <MidasController
 * 	icoSrc="https://www.example.com"
 * 	title="Title"
 * />
 * @returns React.ReactElement
 */
function MidasController(props) {
    return _jsx(StyledComponent, __assign({}, props));
}
MidasController.defaultProps = {
    icoSrc: '',
    title: '',
};
var SampleProps = {};
export default MidasController;
export { SampleProps as MidasControllerSample, };
